import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ElectionCategory, ELECTION_CATEGORIES } from '../../constants/categories';

export { getCategoryLabel } from '../../constants/categories';

// Send exactly these values; any other returns 422
export type VoterSignCategory = ElectionCategory;

export const VOTER_SIGN_CATEGORIES = ELECTION_CATEGORIES;

export interface PartyLeaderOut {
  slot: number;
  name: string | null;
  size_bytes: number;
}

export interface VoterSignItem {
  id: string;
  name_hi: string;
  name_en: string | null;
  // null for signs uploaded before categories existed: Admins don't see them until one is set
  category: VoterSignCategory | null;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  size_bytes: number;
  // How many election-app Admins have chosen this sign (delete is blocked while > 0)
  admin_count: number;
  party_name: string | null;
  leaders: PartyLeaderOut[];
}

export interface VoterSignState {
  items: VoterSignItem[];
  total: number;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
}

const initialState: VoterSignState = {
  items: [],
  total: 0,
  limit: 25,
  offset: 0,
  loading: false,
  error: null,
};

const voterSignSlice = createSlice({
  name: 'voterSigns',
  initialState,
  reducers: {
    setVoterSignLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setVoterSignError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setVoterSignPage: (
      state,
      action: PayloadAction<{ items: VoterSignItem[]; total: number; limit: number; offset: number }>
    ) => {
      const { items, total, limit, offset } = action.payload;
      state.items = items;
      state.total = total;
      state.limit = limit;
      state.offset = offset;
    },
    updateVoterSignReducer: (state, action: PayloadAction<VoterSignItem>) => {
      const idx = state.items.findIndex((s) => s.id === action.payload.id);
      if (idx !== -1) state.items[idx] = action.payload;
    },
  },
});

export const {
  setVoterSignLoading,
  setVoterSignError,
  setVoterSignPage,
  updateVoterSignReducer,
} = voterSignSlice.actions;

export default voterSignSlice.reducer;
